<!-- Sezione filtri -->
<mat-card-content class="table-header">
    @for(field of filterFields; track field) {
    <input matInput #inputRef [placeholder]="'Filtra per ' + filterLabels[field]?.join(' o ') || field" (input)="onInputChange(field, inputRef.value)" class="input-filter" /> }
</mat-card-content>